"use strict";

angular.module("broadcastsModule").controller("BroadcastMediaUpload", [
  "$scope",
  "$window",
  "folderId",
  "BroadcastsUploader",
  "BroadcastsFile",
  "DS",
  function ($scope, $window, folderId, Uploader, BroadcastsFile, DS) {
    /**
     * methods
     */
    this.onSuccessItem = function (fileItem, responseData) {
      BroadcastsFile.inject(responseData);
      DS.emit("media-file-uploaded", responseData);
    };
    /**
     * scope members
     */
    this.uploader = new Uploader({
      autoUpload: true,
      onSuccessItem: this.onSuccessItem,
      formData: [{ folder_id: folderId }],
    });
  },
]);
